import {
  __async
} from "./chunk-WNQUEZJF.mjs";

// src/events/foreground-event/foreground-event.ts
import { fireEvent } from "@youversion/analytics-core";
function fireForegroundEvent(options) {
  return __async(this, null, function* () {
    const foregroundEvent = {
      _type: "v2.ForegroundEvent",
      contentType: "none",
      /**
       * In mobile land referrer is the link you used to launch the app (deeplink, notifcation, etc).
       * In web land its the site you were on before.
       * What we want ExternalReferrerUri to mean cross platform is what link did you click on to
       * "launch" our app. For web that's window.location.href.
       * This is so that we can pull out UTM parameters for comms link tracking.
       */
      externalReferrerUri: window.location.href,
      source: "link"
    };
    fireEvent(foregroundEvent, options);
  });
}
var Foreground = {
  fire: fireForegroundEvent
};

export {
  Foreground
};
